module.exports = __webpack_public_path__ + "35225170b5b5970f16b687e8001cd0df.glb";